module.exports = __webpack_public_path__ + "static/media/delete-white.40a0224a.svg";